
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(8),
  partnerId: Number,
  creative: Number,
  lp: Number,
  aid: Number,
  accountHash: String.withConstraint(x => x.length <= 256),
  event_mapping_version: Literal(2),
}).And(Partial({
  client_timestamp: Number.withConstraint(x => x >= 0),
  referrer: String.withConstraint(x => x.length <= 256),
  placement: String.withConstraint(x => x.length <= 100),
  keyword: String.withConstraint(x => x.length <= 150),
  network: String.withConstraint(x => x.length <= 1),
  cid: String.withConstraint(x => x.length <= 25),
  tid: String.withConstraint(x => x.length <= 25),
  camp: Number,
  adgr: Number,
  matchtype: String.withConstraint(x => x.length <= 1),
  journeyHash: Number,
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(8),
  partnerId: Number,
  creative: Number,
  lp: Number,
  aid: Number,
  accountHash: String.withConstraint(x => x.length <= 256),
  event_mapping_version: Literal(2),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
  instanceId: Number.withConstraint(x => x >= 0 && x <= 1000),
  lang: String.withConstraint(x => x.length <= 5),
}).And(Partial({
  client_timestamp: Number.withConstraint(x => x >= 0),
  referrer: String.withConstraint(x => x.length <= 256),
  placement: String.withConstraint(x => x.length <= 100),
  keyword: String.withConstraint(x => x.length <= 150),
  network: String.withConstraint(x => x.length <= 1),
  cid: String.withConstraint(x => x.length <= 25),
  tid: String.withConstraint(x => x.length <= 25),
  camp: Number,
  adgr: Number,
  matchtype: String.withConstraint(x => x.length <= 1),
  journeyHash: Number,
  zoneId: Number.withConstraint(x => x >= 0 && x <= 1000),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 8;
  